<!--赢在录取（学生成长中心）：学霸讲专业 + 专业知晓-->
<template>
    <div class="enroll-home">
        <div class="enroll-panel">
            <!--学霸讲专业-->
            <div v-show="activeTab==='major'" class="enroll-tab-body">
                <!--列表模式-->
                <div class="major-page" v-show="majorMode==='page'">
                    <!-- 搜索条件 -->
                    <div class="form-box">
                        <el-form ref="queryForm"
                                 :model="queryParams"
                                 :inline="true"
                                 label-width="40px">
                            <el-row class="mt10 ml10" >
                                <el-col :span="4" class="mb0">
                                    <el-form-item label="类型">
                                        <el-select clearable @change="pageCourse(null)" v-model="queryParams.stageType" placeholder="请选择">
                                            <el-option v-for="item in courseClassifyList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" class="mb0">
                                    <el-form-item label="学段">
                                        <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" class="mb0">
                                    <el-form-item label="年级">
                                        <el-select clearable @change="pageCourse(null)" v-model="queryParams.gradeKey" placeholder="请选择">
                                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="mr0 mb0"></el-col>
                                <el-col :span="6" class="mr0 mb0">
                                    <el-form-item class="pull-right">
                                        <el-input v-model="queryParams.courseName" placeholder="请输入课程名称" class="input-with-select">
                                            <template #append>
                                                <el-button type="primary" @click="pageCourse(null)" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="right-container">
                        <div class="page-info-container">
                            <div class="info-list-container">
                                <div class="course-list-box">
                                    <div class="course-item" v-for="item in dataList" :key="item.courseId">
                                        <el-card @click="viewCourse(item)" :body-style="{ padding: '0px' }" class="course-one">
                                            <div class="course-name">{{item.courseName}}</div>
                                            <div class="course-info">
                                                <div class="course-cover">
                                                    <img class="img-100" :src="item.courseCover" alt />
                                                </div>
                                                <div class="course-title">
                                                    <div class="course-subject">主讲人：{{item.userName?item.userName:'--'}}</div>
                                                    <div class="course-subject"></div>
                                                    <div class="course-subject">课程类型：{{item.stageTypeName?item.stageTypeName:'--'}}</div>
                                                    <div class="course-stats">
                                                        <div class="stpBox">
                                                            <img class="mr3"  style="width: 16px;height:16px" src="../../assets/image/dz.png" alt>
                                                            {{ item.likeCount }}
                                                        </div>
                                                        <div class="stpBox">
                                                            <el-icon class="mr3">
                                                                <Star/>
                                                            </el-icon>
                                                            {{ item.collectCount }}
                                                        </div>
                                                        <div class="stpBox">
                                                            <el-icon class="mr3">
                                                                <View/>
                                                            </el-icon>
                                                            {{ item.viewCount }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </div>
                                </div>
                                <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                            </div>
                            <div class="page-container" v-if="dataList&&dataList.length>0">
                                <pageTag :background="true"
                                         :pageSizes="[6, 9, 12]"
                                         v-show="total > 0"
                                         :total="total"
                                         v-model:page.sync="queryParams.pageNum"
                                         v-model:limit.sync="queryParams.pageSize"
                                         @pagination="pageCourse" />
                            </div>
                        </div>
                    </div>
                </div>
                <!--详情模式-->
                <div class="major-detail" v-if="majorMode==='detail'">
                    <course-info :course-id="this.courseId" :classify="queryParams.stageType"
                                 @change-mode="changeModel"/>
                </div>
            </div>

            <!--专业知晓-->
            <div v-show="activeTab==='know'" class="enroll-tab-body">
                <!--文件列表-->
                <div v-show="knowMode==='list'" class="zyzx-body">
                    <!--目录-->
                    <div class="zyzx-side">
                        <div class="zyzx-side-title">目录</div>
                        <el-scrollbar class="zyzx-tree-scroll">
                            <el-tree
                              class="zyzx-tree"
                              :data="categoryList"
                              :props="defaultProps"
                              @node-click="handleNodeClick">
                            </el-tree>
                        </el-scrollbar>
                    </div>
                    <!--文件卡片-->
                    <div class="zyzx-main">
                        <div class="zyzx-search">
                            <svg t="1775018007241" class="icon cursor" @click="resetSearch" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8064" width="30" height="30"><path d="M512 57.677643C261.084506 57.677643 57.677643 261.084506 57.677643 512s203.406863 454.322357 454.322357 454.322357 454.322357-203.406863 454.322357-454.322357S762.915494 57.677643 512 57.677643z" fill="#0d55a4" p-id="8065" data-spm-anchor-id="a313x.search_index.0.i11.35603a81rpIomP" class="selected"></path><path d="M581.060548 231.577511c-41.567834-41.568721-84.297206-66.239667-95.428104-55.108769-11.137997 11.137109 13.540936 53.86027 55.108769 95.428991a399.812548 399.812548 0 0 0 3.868839 3.816485c-18.446198-2.465941-38.703473-3.828908-59.958128-3.828908-77.080402 0-141.021837 17.917338-153.042745 41.397463-17.152444 22.420631-29.056222 71.617886-29.056222 128.705442 0 78.219757 22.352305 141.629671 49.931092 141.629671 27.578787 0 49.939965-63.409913 49.939965-141.629671 0-29.986163-3.285851-57.794773-8.891231-80.689248 25.579591 5.930149 57.067147 9.428076 91.118253 9.428076 22.752499 0 44.362094-1.561733 63.828742-4.367528a399.907494 399.907494 0 0 0-7.739452 7.534475c-41.568721 41.568721-66.240555 84.298094-55.109657 95.428991 11.137109 11.137109 53.86027-13.540049 95.428991-55.10877 34.770745-34.770745 57.718461-70.344541 57.776139-87.567972a16.620035 16.620035 0 0 0 0.897109-5.344499c0-2.19175-0.448111-4.351556-1.316825-6.468769-3.259231-18.402718-25.271681-51.17338-57.355535-83.25546z m40.5181 350.441373c0 29.983501 3.284076 57.788562 8.887681 80.682149-25.582253-5.927487-57.071584-9.425414-91.124464-9.425414-22.751612 0-44.360319 1.561733-63.825193 4.365754a405.916617 405.916617 0 0 0 7.747439-7.542461c41.568721-41.568721 66.240555-84.285671 55.102558-95.42278-11.130898-11.130898-53.853172 13.533837-95.42278 55.102558-34.768971 34.768971-57.715799 70.348977-57.779688 87.573296a16.628908 16.628908 0 0 0-0.894447 5.340063c0 2.184652 0.444562 4.337359 1.307064 6.447473 3.242371 18.400055 25.269019 51.187577 57.367958 83.287403 41.568721 41.567834 84.285671 66.240555 95.42278 55.102559 11.130898-11.130898-13.533837-53.853172-55.102558-95.42278a410.577858 410.577858 0 0 0-3.868839-3.81826c18.440873 2.466828 38.693712 3.828908 59.945706 3.828908 77.092825 0 141.048458-17.930648 153.056943-41.416985 17.148007-22.42773 29.051785-71.612562 29.051785-128.681483 0-78.228631-22.361179-141.638544-49.939966-141.638544-27.578787 0-49.931092 63.409913-49.931091 141.638544z" fill="#FFFFFF" p-id="8066"></path></svg>
                            <el-input v-model="fileQuery.fileName" placeholder="请输入文件名称" clearable
                                      class="zyzx-search-input"
                                      @keyup.enter="queryFileList(null)">
                                <template #append>
                                    <el-button type="primary" @click="queryFileList(null)" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </div>
                        <div class="zyzx-card-container" v-loading="fileLoading">
                            <el-empty v-if="!fileLoading && fileList.length == 0" description="暂无数据" />
                            <div v-for="(item, index) in fileList" :key="index" class="zyzx-card">
                                <img class="zyzx-card-cover"
                                     :src="item.fileCover || defaultCover"
                                     @click="handleView(item)" />
                                <div class="zyzx-card-name" :title="item.fileName">{{ item.fileName }}</div>
                            </div>
                        </div>
                        <div class="zyzx-pagination">
                            <pagination :background="false"
                                        :pageSizes="[12, 24, 36]"
                                        :total="fileTotal"
                                        v-model:page="fileQuery.pageNum"
                                        v-model:limit="fileQuery.pageSize"
                                        @pagination="queryFileList" />
                        </div>
                    </div>
                </div>
                <!--文件预览-->
                <div v-show="knowMode==='view'" class="zyzx-view">
                    <div class="zyzx-view-head">
                        <div class="zyzx-view-title" :title="fileForm.fileName">{{ fileForm.fileName }}</div>
                        <el-button class="zyzx-download-btn" type="primary" size="small" icon="Download"
                                   @click="handleDownload">下载</el-button>
                    </div>
                    <file-image-preview v-if="imagePreviewMode" class="zyzx-view-preview"
                                        :title="fileForm.fileName" :img-url="fileForm.imgUrl" :pages="fileForm.pages" />
                </div>
            </div>
        </div>
        <!--图片文件预览-->
        <el-dialog v-model="imageVisible" :title="fileForm.fileName" width="60%" top="5vh" append-to-body>
            <div class="zyzx-image-view">
                <img :src="fileForm.fileUrl" :alt="fileForm.fileName" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import courseInfo from "@/components/course/courseInfo.vue";
import {famousCoursePageFamousCourses} from "@/api/admin/famousCourse";
import {queryDict} from "@/api/admin/public";
import {treeFileCategory, pageCategoryFile, infoFile} from "@/api/admin/fileCategory"
import {downloadFile} from "@/api/adminservice/public"
import fileImagePreview from "@/components/material/fileImagePreview.vue"

export default {
    name: "winEnrollHome",
    components: {pageTag, dataEmpty, courseInfo, fileImagePreview},
    props: {
        title: {
            type: String,
            default: '赢在录取'
        },
        courseMode: {
            type: String,
            default: 'page'
        },
        /*当前Tab：major-学霸讲专业 know-专业知晓（Tab在父级返回行中）*/
        activeTab: {
            type: String,
            default: 'major'
        },
    },
    data() {
        return {
            /*供父级判断：view-处于详情/预览 list-处于列表*/
            showMode: 'list',
            /*学霸讲专业*/
            majorMode: 'page',
            courseClassifyList: [],
            periodList: [],
            gradeList: [],
            queryParams: {
                courseName: '',
                status: 1,
                stageType: '',
                periodKey: '',
                gradeKey: '',
                courseType: 3,// 0-培训课程 1-名师优课 2-英语强化 3-学霸讲专业
                pageNum: 1,
                pageSize: 6,
            },
            total: 0,
            dataList: [],
            courseId: '',
            /*专业知晓*/
            knowMode: 'list',
            defaultCover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/zyzx_file.png',
            fileLoading: false,
            categoryList: [],
            defaultProps: {
                children: 'children',
                label: 'categoryName',
            },
            //查询文件分页
            fileQuery: {
                pageNum: 1,
                pageSize: 12,
                categoryProfile: '5',
                categorySubject: '',
                fileName: '',
                categoryId: '',
            },
            fileTotal: 0,
            fileList: [],
            //文件预览
            fileForm: {},
            //图片预览弹窗
            imageVisible: false,
            //word/pdf/ppt按页图片预览模式
            imagePreviewMode: false,
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getQueryDict();
        this.pageCourse();
        this.queryTreeCategory();
        this.queryFileList(null);
    },
    mounted(){},
    methods: {
        /*==================== 学霸讲专业 ====================*/
        getQueryDict() {
            queryDict({ code: 'talk_profession' }).then(res => {
                this.courseClassifyList = res.data.data;
            })
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageCourse()
        },
        pageCourse(e){
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            famousCoursePageFamousCourses(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    res.data.data.list.forEach(e => {
                        this.courseClassifyList.forEach(j => {
                            if (e.stageType == j.dictKey) {
                                e.stageTypeName = j.dictValue
                            }
                        })
                    })
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.dataList.sort(function (a, b) {
                        if (a.releaseTime > b.releaseTime) { return -1; }
                        if (a.releaseTime < b.releaseTime) { return 1; }
                        return 0;
                    })
                    this.total = res.data.data.total;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewCourse(item){
            this.majorMode = "detail"
            this.showMode = 'view';
            this.courseId = item.courseId;
            this.$emit('change-mode', this.majorMode);
        },
        changeModel(item){
            this.majorMode = item
            this.showMode = 'list';
            this.$emit('change-mode', this.majorMode);
        },
        /*==================== 专业知晓 ====================*/
        // 查询树结构
        queryTreeCategory(){
            treeFileCategory({
                categoryProfile: this.fileQuery.categoryProfile,
                categorySubject: this.fileQuery.categorySubject,
            }).then(res => {
                if (res.data.code === 1) {
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        handleNodeClick(e){
            this.fileQuery.categoryId = e.categoryId;
            this.queryFileList();
        },
        resetSearch(){
            this.fileQuery.fileName = '';
            this.fileQuery.categoryId = '';
            this.queryFileList(null);
        },
        queryFileList(e){
            this.fileLoading = true
            this.fileList = [];
            if (e) {
                this.fileQuery.pageNum = e.page;
                this.fileQuery.pageSize = e.limit;
            }
            pageCategoryFile(this.fileQuery).then(res => {
                if (res.data.code === 1) {
                    this.fileTotal = res.data.data.total;
                    this.fileList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.fileLoading = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 预览文件
        handleView(file){
            infoFile({fileId: file.fileId}).then((res) => {
                if (res.data.code === 1) {
                    this.fileForm = res.data.data;
                    // fileType为文件后缀名，统一转小写并去掉可能带有的前缀点，不区分大小写
                    const fileType = (this.fileForm.fileType || '').toLowerCase().replace(/^\./, '');
                    // 图片文件：直接弹窗展示图片
                    if (/^(png|jpe?g|gif|bmp|webp|svg)$/.test(fileType)) {
                        this.imageVisible = true;
                        return;
                    }
                    // word/pdf/ppt文件：页内按页图片预览，替换iframe方式
                    if (/^(doc|docx|pdf|ppt|pptx)$/.test(fileType)) {
                        if (this.fileForm.imgUrl && Number(this.fileForm.pages) > 0) {
                            this.imagePreviewMode = true;
                            this.knowMode = 'view';
                            this.showMode = 'view';
                        } else {
                            this.$message.info("文件正在处理，请稍后刷新预览")
                        }
                        return;
                    }
                    // 其他文件暂不支持预览，提示用户下载使用
                    this.handleUnsupport(this.fileForm);
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 暂不支持预览的文件，提示下载使用
        handleUnsupport(file){
            this.$confirm("暂不支持预览，可下载使用", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                downloadFile(file.fileUrl, file.fileName);
            }).catch(() => {});
        },
        // 下载文件
        handleDownload(){
            downloadFile(this.fileForm.fileUrl, this.fileForm.fileName);
        },
        /*详情/预览中由顶部返回按钮调用，返回当前Tab列表*/
        backList(){
            if (this.activeTab === 'major') {
                this.majorMode = 'page';
            } else {
                this.knowMode = 'list';
            }
            this.showMode = 'list';
            this.imagePreviewMode = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.enroll-home {
    width: 100%;
}

.enroll-panel {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 24px;
    box-sizing: border-box;
    height: calc(100vh - 174px);
    min-height: 0;
    overflow: hidden;
}

/*Tab内容区*/
.enroll-tab-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

/*==================== 学霸讲专业（pageCourse 风格） ====================*/
.major-page{
    width: 100%;
    flex: 1;
    min-height: 0;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-top: 10px;
}
.form-box{
    width: 100%;
    height: 70px;
    flex-shrink: 0;
    margin: auto;
    border-bottom: 2px solid #0d55a4;
    background-color: #fff;
    padding: 10px 20px 10px 10px;
    box-sizing: border-box;
}
.right-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
}
.page-info-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-list-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin: auto;
    overflow-x: hidden;
    overflow-y: auto;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-left: 4px;
    padding-bottom: 10px;
    align-items: center;
}
.course-item{
    width: 33.3%!important;
    height: 190px;
    padding: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 120px;
}
.course-cover{
    width: 50%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 50%;
    height: 100%;
}
.course-name{
    box-sizing: border-box;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
}
.course-stats{
    width: 100%;
    height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.stpBox {
    width: 33.3%;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    flex-shrink: 0;
    padding-top: 15px;
    box-sizing: border-box;
}
.major-detail{
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: auto;
}

/*==================== 专业知晓（圈考点模块风格） ====================*/
.zyzx-body {
    flex: 1;
    min-height: 0;
    display: flex;
    gap: 20px;
    padding: 16px 26px 22px;
    box-sizing: border-box;
}

/*目录*/
.zyzx-side {
    flex-shrink: 0;
    width: 220px;
    display: flex;
    flex-direction: column;
    background: #f2f8ff;
    border-radius: 16px;
    padding: 14px;
    box-sizing: border-box;
    min-height: 0;
}

.zyzx-side-title {
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 700;
    color: #17365d;
    margin-bottom: 10px;
}

.zyzx-tree-scroll {
    flex: 1;
    min-height: 0;
}

.zyzx-tree {
    background: transparent;
}

/*文件卡片*/
.zyzx-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.zyzx-search {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    .zyzx-search-input {
        max-width: 260px;
    }
}

.zyzx-card-container {
    flex: 1;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    /*无数据时暂无数据提示居中*/
    :deep(.el-empty) {
        margin: auto;
    }
}

.zyzx-card {
    width: 200px;
    margin: 0 16px 16px 0;
    background: #ffffff;
    border: 1px solid #e4eefb;
    border-radius: 16px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-4px);
    }
}

.zyzx-card-cover {
    width: 100%;
    height: 150px;
    object-fit: fill;
    display: block;
}

.zyzx-card-name {
    padding: 8px 12px;
    font-size: 14px;
    color: #17365d;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.zyzx-pagination {
    flex-shrink: 0;
    position: relative;

    /*覆盖分页组件内联的 absolute/right:0，使其居中*/
    :deep(.el-pagination) {
        position: static !important;
        justify-content: center;
    }
}

/*文件预览*/
.zyzx-view {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 16px 26px 22px;
    box-sizing: border-box;
}

.zyzx-view-head {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}

.zyzx-view-title {
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: #0d55a4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/*下载按钮：固定在标题行最右侧*/
.zyzx-download-btn {
    flex-shrink: 0;
    margin-left: 12px;
    background-color: #0d55a4;
    border-color: #0d55a4;
}

/*word/pdf/ppt按页图片预览*/
.zyzx-view-preview {
    flex: 1;
    min-height: 0;
    width: 100%;
}

/*图片预览*/
.zyzx-image-view {
    display: flex;
    justify-content: center;
    max-height: calc(100vh - 200px);
    overflow: auto;
    background: #f2f8ff;
    border-radius: 12px;

    img {
        max-width: 100%;
        display: block;
    }
}
</style>
